import { MAIN_COLORS } from './colors';
import { keyframes } from "styled-components";

export const slideOut = keyframes`
  0%{
    transform: translateY(0px);
    opacity: 1;
  }
  100%{
    transform: translateY(150%);
    opacity: 0;
  }
`

export const slidein = keyframes`
  0%{
    transform: translateY(150%);
    opacity: 0;
  }
  100%{
    transform: translateY(0px);
    opacity: 1;
  }
`

export const appear = keyframes`
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
`

export const disappear = keyframes`
  0%{
    opacity: 1;
  }
  100%{
    opacity: 0;
  }
`

export const pulse = keyframes`
  0% {
      background-position: -200% 0;
      opacity: 0.6;
  }
  50% {
      opacity: 1;
  }
  100% {
      background-position: 200% 0;
      opacity: 0.6;
  }
`

export const colorShift = keyframes`
  0% {
    opacity: 0.4
  }
  50% {
    opacity: 1
  }
  100%{
    opacity: 0.4
  }
`

export const shake = keyframes`
  0% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  50% { transform: translateX(5px); }
  75% { transform: translateX(-5px); }
  100% { transform: translateX(0); }
`;

export const confettiFall = keyframes`
  0% {
    transform: translateY(-100%) rotate(0deg);
    opacity: 1;
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
    opacity: 0;
  }
`;

export const bonusPop = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const shimmer = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

export const progressFill = keyframes`
  0% {
    width: 0%;
  }
  100% {
    width: var(--progress-width);
  }
`;

export const particleRise = keyframes`
  0% {
    transform: translateY(0) scale(1);
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateY(-80vh) scale(0);
    opacity: 0;
  }
`;

export const starPop = keyframes`
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

export const edgeFlash = keyframes`
  0% { opacity: 0; }
  30% { opacity: 1; }
  100% { opacity: 0; }
`;

export const cardGlowPulse = keyframes`
  0%, 100% { box-shadow: 0 0 0px transparent; }
  50% { box-shadow: 0 0 30px var(--glow-color, rgba(185, 0, 255, 0.4)); }
`;

export const shimmerSweep = keyframes`
  0% { transform: translateX(-200%); }
  100% { transform: translateX(400%); }
`;

export const textReveal = keyframes`
  0% { opacity: 0; transform: translateY(15px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const maxLevelEnter = keyframes`
  0% { transform: scale(0.1) rotate(-15deg); opacity: 0; }
  40% { transform: scale(1.3) rotate(5deg); }
  60% { transform: scale(0.9) rotate(-2deg); }
  80% { transform: scale(1.05) rotate(1deg); }
  100% { transform: scale(1) rotate(0deg); opacity: 1; }
`;